export default {
  state: () => ({
    testimonials: [
      {
        image: "https://cdn.vuetifyjs.com/images/cards/sunshine.jpg",
        name: "Ana Perez",
        age: "20",
        condition: "Cataratas",
        comment:
          "“Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor inci-didunt ut labore et dolore magna aliqua ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.” ",
      },
      {
        image: "https://cdn.vuetifyjs.com/images/cards/sunshine.jpg",
        name: "Juana Maltinez",
        age: "30",
        condition: "Astigatismo",
        comment:
          "“Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor inci-didunt ut labore et dolore magna aliqua ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.” ",
      },
      {
        image: "https://cdn.vuetifyjs.com/images/cards/sunshine.jpg",
        name: "Juancho Ruiz",
        age: "13",
        condition: "Conjuntivitis",
        comment:
          "“Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor inci-didunt ut labore et dolore magna aliqua ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.” ",
      },
    ],
  }),
  getters: {
    getTestimonials: (state) => state.testimonials,
  },
  actions: {},
  mutations: {},
  namespaced: true,
};
